<template>
  <Layout>
    <template v-slot:quickmsg>
      <transition name="fade">
        <div v-if="quickmsg!=''">{{quickmsg}}</div>
      </transition>
    </template>
    <!--Table-->
    <table id="tablePreview" class="table">
      <!--Table head-->
      <thead>
        <tr>
          <th colspan="8">
            Poziom graniczny
            <input
              type="number"
              min="0"
              max="100"
              class="right f14"
              v-model="poziomGranicznyProcent"
              @change="mthGetProducts()"
            />
            % &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              v-if="false"
              type="number"
              placeholder="filtr"
              v-model="filter"
              @change="mthGetProducts()"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              v-if="false"
              type="number"
              min="5"
              max="10000"
              step="1"
              placeholder="porcja"
              v-model="portion"
              @change="mthGetProducts()"
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mdb-icon size="2x" class="orange-text pr-3" icon="print" title="Raport" />

            <!-- odświeżaj -->
            <mdb-btn
              v-if="false"
              @click="mthSwitchLive()"
              icon="sync"
              :gradient="mthGetRefreshButtonGradientByLiveMode()"
            >ODŚWIEŻAJ</mdb-btn>

            <!-- odśwież -->
            <mdb-btn @click="mthRefresh()" icon="sync">ODŚWIEŻ</mdb-btn>

            <mdb-btn
              @click="mthShippingSwitchto"
              :gradient="mthGetShippingButtonGradientByShippingMode()"
            >Dostawa</mdb-btn>

            <mdb-btn @click="mthShippingSave" gradient="peach">Zatwierdź dostawę</mdb-btn>

            <Shipments
              v-on:shipments-set="mthLoadShipmentFromEnova($event)"
            ></Shipments>

          </th>
        </tr>
        <tr>
          <th colspan="4"></th>
          <th colspan="4" style="width: 50%">L O K A L I Z A C J E</th>
        </tr>

        <tr>
          <th>#</th>
          <th>
            <span v-if="userstore && userstore.typ=='admin'">Włącz/wyłącz</span>
          </th>
          <th>Numer katalogowy</th>
          <th>Nazwa produktu</th>
          <th colspan="3" class="center">Półka / Podręczny / Palety</th>
          <th>
            Ilość
            <br />łączna
          </th>
        </tr>
      </thead>
      <!--Table head-->
      <!--Table body for loading data message-->
      <tbody v-if="loading">
        <tr>
          <td colspan="100" class="loading">Proszę czekać, trwa ładowanie produktów ...</td>
        </tr>
      </tbody>
      <!--Table body with data-->
      <tbody v-if="!loading">
        <!-- pager -->
        <tr>
          <td align="center" colspan="8">
            <template v-for="item in Math.ceil(arrPagingProductsCounter/arrpagingPagesize)">
              <span @click="mthSetPage(item)" :class="mthGetClassForPagerButton(item)">{{item}}</span>
            </template>
          </td>
        </tr>
        <tr
          v-for="(item,index) in products"
          :key="'row'+index+refresher"
          :class="mthGetActiveRowClassByState(index)+' '+mthGetCssClassBySortingKey(parseInt(item.sortingKey))"
        >
          <template v-if="shippingMode==false || (item.stan_cache > mthSumABC(item))">
            <td scope="row" :title="item.id">{{index+1}}</td>
            <td align="left">
              <!-- Default switch -->
              <div v-if="userstore && userstore.typ=='admin'" class="custom-control custom-switch">
                <!-- switch włącz wyłącz -->
                <input
                  @change="mthSaveSwitchState(item,index)"
                  type="checkbox"
                  class="custom-control-input"
                  :id="'switch'+index"
                  :checked="mthIntToBool(item.swmWlaczony)"
                  :key="'switch1'+refresher"
                />
                <label class="custom-control-label" :for="'switch'+index"></label>
              </div>

              <!-- zapisz save -->
              <transition name="fade">
                <mdb-btn
                  @click="mthValidateAndSaveProductData(item)"
                  v-if="item.swmWlaczony==1 && userstore && userstore.typ=='admin'"
                  icon="check-circle"
                  gradient="peach"
                  class="savebtn"
                >Zapisz</mdb-btn>
              </transition>
            </td>
            <td>{{item.nr_kat}}</td>
            <td>{{item.nazwa}}</td>
            <td colspan="3">
              <transition name="fade">
                <Boxes
                  :product="item"
                  :shippingModeWatched="shippingMode"
                  :rewriteShipmentToBigboldiesRequestWatched="rewriteShipmentToBigboldiesRequest"
                  :key="'box'+refresher"
                  v-if="item.swmWlaczony==1"
                  v-on:boxchanged="mthBoxChanged($event,index)"
                  v-on:shipment-copied-to-big-boldies="mthShipmentCopiedToBigBoldies($event,index)"
                ></Boxes>
              </transition>
            </td>
            <td :title="item.stan_cache_data">{{item.stan_cache | filterInt}}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </Layout>
</template>
     

<script>
import { mdbIcon, mdbBtn } from "mdbvue";
import Boxes from "./Boxes";
import Shipments from "./Shipments";
import moment from "moment";

export default {
  name: "warehouse",
  data() {
    return {
      shippingMode: false,
      enovaShipmentDate: '', //if set, only products from this shipment will be loaded
      liveMode: false,
      loading: true,
      rewriteShipmentToBigboldiesRequest: false,
      refresher: 0,
      arrpagingPagesize: 100,
      arrpagingPages: 1,
      arrpagingCurrentPage: 1,
      arrPagingProductsCounter: -1, //have to read from api
      filter: "",
      userstore: {},
      products: [],
      quickmsg: "",
      intervalFunction: {},
      intervalIndex: -1,
      poziomGranicznyProcent: 10
    };
  },
  created() {
    this.mthLoadUserFromLocalstore();
    this.mthGetProducts();
  },
  mounted() {
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;

      if (bottomOfWindow) {
        console.log("bottom");
      }
    };
  },
  methods: {
    mthLoadShipmentFromEnova(dataDostawy){
      console.log('event from Shipments component: ');
      console.log(dataDostawy);
      this.enovaShipmentDate = dataDostawy;
      this.mthGetProducts();

    },
    mthGetClassForPagerButton(num){
      
      if(this.arrpagingCurrentPage==num) return 'pagingbutton activepagingbutton';
      
      return 'pagingbutton';
    },
    mthSetPage(num){
      console.log('setting page to '+num);
      this.arrpagingCurrentPage=num;
      this.mthGetProducts();
    },
    mthRefresh() {
      this.mthGetProducts();
    },
    mthGetRefreshButtonGradientByLiveMode() {
      if (!this.liveMode) return "winter-neva";

      return "young-passion";
    },
    mthGetShippingButtonGradientByShippingMode() {
      if (!this.shippingMode) return "winter-neva";

      return "young-passion";
    },
    mthShipmentCopiedToBigBoldies(event, index) {
      console.log("warehouse knows");
      console.log(event);
      this.rewriteShipmentToBigboldiesRequest = false;
      this.shippingMode = false;
    },
    mthShippingSave() {
      this.rewriteShipmentToBigboldiesRequest = true;
    },
    mthShippingSwitchto() {
      this.shippingMode = !this.shippingMode;
    },
    mthSumABC(item) {
      var ret = 0;

      if (item.swmWlaczony == 1) {
        if (item.swmApolka_wlaczone && item.swmApolka > 0)
          ret += item.swmApolka;
        if (item.swmBpodreczny_wlaczone && item.swmBpodreczny > 0)
          ret += item.swmBpodreczny;
        if (item.swmCpalety_wlaczone && item.swmCpalety > 0)
          ret += item.swmCpalety;
      }
      //console.log(ret);

      return ret;

      //return 0;
    },
    mthGetActiveRowClassByState(index) {
      if (this.intervalIndex == index && this.liveMode) return "livetr";

      return "";
    },
    mthSwitchLive() {
      //console.log(item);

      if (this.liveMode == true) {
        clearInterval(this.intervalFunction);

        //clear all intervals
        //var interval_id = setInterval("", 9999);
        //for (var i = 1; i < interval_id; i++) clearInterval(i);

        this.liveMode = false;
        //this.intervalIndex = -1;
      } else {
        this.liveMode = true;
        //this.intervalIndex = index;
        this.intervalFunction = setInterval(() => {
          //this.mthRefreshSingleProduct(item, index);
          this.mthGetProducts();
        }, 5000);
      }
    },
    mthRefreshSingleProduct(item, index) {
      var apiurl =
        this.$config.API_URL +
        "/products?filter=" +
        item.nr_kat +
        "&portion=" +
        this.portion;
      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          //console.log("products:");
          //console.log(response.data);
          that.products[index] = response.data[0];
          //console.log(item)
          console.log(that.products);
          that.refresher++;
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    },

    mthBoxChanged(event, index) {
      console.log("mthBoxChanged for index : " + index);

      //console.log(event);
      this.products[index] = event;
      this.refresher++;
      //console.log(this.products);
    },
    mthSaveProductData(item, validationResult) {
      var apiurl = this.$config.API_URL + "/swmsaveproduct";
      var retmsg = "Błąd: Brak komunikatu zwrotnego dot. zapisu.";
      var that = this;

      this.$axios({
        method: "post",
        url: apiurl,
        data: item,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(response) {
          console.log(response.data);
          that.$swal(response.data + "(walidacja: " + validationResult + ")");
          // setTimeout(() => {
          //   that.quickmsg = "";
          // }, 3000);
        })
        .catch(function(error) {
          console.log(error);
          that.$swal("axios Błąd: " + error);
        });
    },
    mthValidateSingleProduct(item) {
      //should return OK or message

      // id: "985";
      // nazwa: "SILNIK BRIGGS&STRATTON 17,5 OHV INTEK";
      // nr_kat: "01-01001";
      // stan_cache: "47.00";
      // stan_cache_data: "2019-03-21 02:40:02";
      // swmApolka: "0";
      // swmApolka_max: "0";
      // swmBpodreczny: "0";
      // swmBpodreczny_max: "0";
      // swmCpalety: "0";
      // swmCpalety_opis: "ww";
      // swmCpalety_wlaczone: 1;
      // swmWlaczony: "1";
      // swmgraniczny_procent: "0";
      if (item.swmApolka_max == "") return "Wypełnij max dla półki.";
      if (item.swmBpodreczny_max == "") return "Wypełnij max dla podręcznego.";
      if (item.swmCpalety_wlaczone == "1" && item.swmCpalety_opis == "")
        return "Palety są włączone - opis jest obowiązkowy.";

      return "OK";
    },
    mthValidateAndSaveProductData(item) {
      console.log("will save ");
      console.log(item);

      var validationResult = "OK";
      var saveResult = "Błąd. Nie udało się zapisać.";
      validationResult = this.mthValidateSingleProduct(item);

      if (validationResult == "OK") {
        saveResult = this.mthSaveProductData(item, validationResult);
      } else {
        this.$swal("Nieprawidłowe dane: " + validationResult);
      }
    },
    mthIntToBool(value) {
      //console.log('got '+value)

      if (value == 1) return true;
      if (value == "1") return true;
      return false;
    },
    mthSetAttribute(tablename, keyv, attr, val, datatype, succmsg, errmsg) {
      var apiurl =
        this.$config.API_URL +
        "/setattr?table=" +
        tablename +
        "&keyv=" +
        keyv +
        "&attr=" +
        attr +
        "&val=" +
        val +
        "&datatype=" +
        datatype +
        "&succmsg=" +
        succmsg +
        "&errmsg=" +
        errmsg;

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          console.log(response.data);
          that.quickmsg = response.data;

          setTimeout(() => {
            that.quickmsg = "";
          }, 3000);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    mthSaveSwitchState(product, index, value) {
      console.log("mthSaveSwitchState for index: " + index);
      if (this.products[index].swmWlaczony == 0)
        this.products[index].swmWlaczony = 1;
      else this.products[index].swmWlaczony = 0;
      console.log(this.products[index].swmWlaczony);

      // var res = this.mthSetAttribute(
      //   "katalog_products",
      //   this.products[index].id,
      //   "swmWlaczony",
      //   this.products[index].swmWlaczony,
      //   "int",
      //   "Zapisano zmianę w " + this.products[index].nr_kat,
      //   "Błąd - Nie udało się zapisać " + this.products[index].nr_kat
      // );
    },
    mthSortingKeysExpert(p) {
      //1 - PILNE – te których w ilości półkowej jest równa 0 lub poniżej 0 , a towar ten jest nadal dostępny na AKTYWNYCH pozostałych lokalizacjach.
      //– zaznaczone na JASNO CZERWONO
      // (ilość w lokalizacji półkowej może być poniżej zera w przypadku gdy np. na półce mamy 5szt, na palecie 100szt i ktoś zamówi 10szt.
      //Wtedy wynikiem powinno być -5 na półce i 100 na palecie.)
      if (
        p.swmApolka <= 0 &&
        ((p.swmBpodreczny_wlaczone == 1 && p.swmBpodreczny > 0) ||
          (p.swmBpodreczny_wlaczone == 1 && p.swmCpalety > 0))
      )
        return 1;

      // 2 - NA WYCZERPANIU „półka” – te których ilość w lokalizacji „półka” jest poniżej zdefiniowanego poziomu granicznego w porównaniu do zdefiniowanej ilości
      // maksymalnej w danej lokalizacji ale powyżej 0. Dotyczy tylko lokalizacji Aktywnych , czyli gdzie ilość maks nie jest równa 0.
      // A jednocześnie w aktywnej lokalizacji „podręczny” lub „palety” znajdują się jeszcze artykuły – zaznaczone CIEMNO ŻÓŁTYM
      if (
        p.swmApolka_wlaczone == 1 &&
        p.swmApolka / p.swmApolka_max <
          parseFloat(this.poziomGranicznyProcent) / parseFloat(100) &&
        ((p.swmBpodreczny_wlaczone == 1 && p.swmBpodreczny > 0) ||
          (p.swmBpodreczny_wlaczone == 1 && p.swmCpalety > 0))
      )
        return 2;

      // 3 - NA WYCZERPANIU „podręczny” – te których ilość w lokalizacji „podręczny” jest poniżej zdefiniowanego poziomu granicznego w porównaniu do zdefiniowanej
      // ilości maksymalnej w danej lokalizacji. Dotyczy tylko lokalizacji Aktywnych , czyli gdzie ilość maks nie jest równa 0.
      // oraz w przypadku których w Aktywnej lokalizacji „palety” znajdują się jeszcze artykuły – zaznaczone kolorem JASNO ŻÓŁTYM
      if (
        p.swmBpodreczny_wlaczone == 1 &&
        p.swmBpodreczny / p.swmBpodreczny_max <
          parseFloat(this.poziomGranicznyProcent) / parseFloat(100) &&
        (p.swmCpalety_wlaczone == 1 && p.swmCpalety > 0)
      )
        return 3;

      // 4 - KOŃCZĄCE SIĘ – gdzie ilość w lokalizacji „półka” jest poniżej zdefiniowanego poziomu granicznego w porównaniu do zdefiniowanej ilości maksymalnej,
      // ale nie ma już tego artykułu w pozostałych lokalizacjach. – tło JASNO SZARE
      if (
        p.swmApolka_wlaczone == 1 &&
        p.swmApolka / p.swmApolka_max <
          parseFloat(this.poziomGranicznyProcent) / parseFloat(100)
      )
        return 4;

      // 5 - WYŁĄCZONE – te które w 1-wszej kolumnie zostały oznaczone jako wyłączone z analizy – tło CIEMNO SZARE
      if (p.swmWlaczony == 0) return 5;

      // 6 - NIEDOSTĘPNE- te które są włączone ale ich stan we wszystkich lokalizacjach jest 0 szt. – tło NIEBIESKIE
      if (
        p.swmWlaczony == 1 &&
        p.swmApolka == 0 &&
        p.swmBpodreczny == 0 &&
        p.swmCpalety == 0
      )
        return 6;

      return 1000;
    },
    mthGetCssClassBySortingKey(sortingKey) {
      switch (sortingKey) {
        case 1:
          return "key1JasnoCzerwony";
        case 2:
          return "key2CiemnoZolty";
        case 3:
          return "key3JasnoZolty";
        case 4:
          return "key4JasnoSzary";
        case 5:
          return "key5CiemnoSzary";
        case 6:
          return "key6Niebieski";
        default:
          return "key1000bialy";
      }
    },
    // mthSortProducts() {
    //   //list.sort(
    //   //    (a, b) => (a.color > b.color) ? 1
    //   //: (a.color === b.color) ?
    //   //((a.size > b.size) ? 1 : -1) : -1
    //   //)

    //   this.products.sort((a, b) =>
    //     a.sortingKey < b.sortingKey
    //       ? 1
    //       : a.sortingKey === b.sortingKey
    //       ? a.nr_kat > b.nr_kat
    //         ? 1
    //         : -1
    //       : -1
    //   );
    // },
    // mthAddSortingKeys() {
    //   var that = this;

    //   this.products.forEach((p, index) => {
    //     console.log(that.mthSortingKeysExpert(p));
    //     p.sortingKey = that.mthSortingKeysExpert(p);
    //   });
    // },
    mthFillProductsCounter(){
      var apiurl =
        this.$config.API_URL +
        "/productscount";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          
          console.log(response.data.il);
        
          that.arrPagingProductsCounter = parseInt(response.data.il);

        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthGetProducts() {
      this.loading = true;
      var apiurl =
        this.$config.API_URL +
        "/products?filter=" +
        this.filter +
        "&portion=" +
        this.arrpagingPagesize +
        "&offset=" +
        ((this.arrpagingCurrentPage-1)*this.arrpagingPagesize) +
        "&thresholdpercent=" +
        this.poziomGranicznyProcent +
        "&enovaShipmentDate=" +
        this.enovaShipmentDate
        ;

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          console.log("products:");
          console.log(response.data);
          that.products = response.data;
          that.quickmsg = "Dane odświeżono: " + moment().format("HH:mm:ss");
          that.loading = false;
          if(that.arrPagingProductsCounter==-1)
          {
            that.mthFillProductsCounter();
          }
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthLoadUserFromLocalstore() {
      console.log(localStorage.getItem("swmLSuser"));

      if (localStorage.getItem("swmLSuser"))
        this.userstore = JSON.parse(localStorage.getItem("swmLSuser"));
      else this.userstore = {};
    }
  },
  components: {
    mdbIcon,
    Boxes,
    Shipments,
    mdbBtn
  }
};
</script>

<style scoped>
.right {
  text-align: right;
}
.f14 {
  font-size: 14pt;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.savebtn {
  display: block;
  margin: 0;
  margin-top: 20px;
}
tr.livetr {
  background-color: gold;
}
.center {
  text-align: center;
  letter-spacing: 1rem;
}

td.loading {
  font-size: 14pt;
  margin: 50px;
  padding: 50px;
}

.key1JasnoCzerwony {
  background-color: #ff695e;
}
.key2CiemnoZolty {
  background-color: #fff705;
}
.key3JasnoZolty {
  background-color: #fffca1;
}
.key4JasnoSzary {
  background-color: #bababa;
}
.key5CiemnoSzary {
  background-color: #575757;
}
.key6Niebieski {
  background-color: #bec1ff;
}
.key1000bialy {
  background-color: white;
}
.pagingbutton{
  padding: 5px;
  margin: 5px;
  background-color: #bababa;
}
.activepagingbutton{
  background-color: #fff705;
}
</style>